import { FLOW_STEP_TYPES } from './FlowStepDefType';
import MetaDataHelper, { declareEntity } from '../fw/MetaDataHelper.ts';
import { hasSnapshotTestDeveloperPermission } from '../util/SnapshotTestPermission';

export default declareEntity({
    entity: 'testInvocations',
    graphQL: 'TestInvocation',
    name: 'Test Invocation',
    storageType: 'testcase',
    isPublic: false,
    userEditable: false,
    userCreatable: false,
    userDeletable: false,
    permissionFunc: (action, permissionObject) => {
        return hasSnapshotTestDeveloperPermission(permissionObject);
    },
    fields: (types) => { return {
        id: { name: 'ID', type: 'ID', primaryKey: true, required: true, isPublic: true },
        organisation_id: { type: 'relation', to: () => types['organisations'] },
        name: { type: 'string' },
        lastStatus: { type: 'string', isPublic: true },
        lastRunAt: { type: 'datetime', isPublic: true },
        lastDuration: { type: 'int', isPublic: true },
        lastError: { type: 'text', isPublic: true },
        expectedOutput: { type: 'object' },
        expectedOutputPreview: { type: 'string', controllerFn: 'getExpectedOutputPreview' },
        version: { type: 'int', isPublic: true },
        createdAt: { type: 'datetime' },
        updatedAt: { type: 'datetime' },
        flowDef_id: { type: 'relation', to: () => types['flowDefs'] },
        flowDefVersion_id: { type: 'relation', to: () => types['flowDefVersions'] },
        flow_id: { type: 'relation', to: () => types['flows'] },
        sourceFlowInvocation_id: { type: 'relation', to: () => types['flowInvocations'] },
        realId: { type: 'string', controllerFn: 'getRealId' },
        lastSuccessfulRun: { type: 'relation', to: () => types['testRuns'], controllerFn: 'getLastSuccessfulRun' },
        lastUnsuccessfulRun: { type: 'relation', to: () => types['testRuns'], controllerFn: 'getLastUnsuccessfulRun' },
        environmentState: { type: 'object' },
        fetchIds: { type: 'object' },
        author_id: { type: 'relation', to: () => types['users'] },
        startFlowStepDef_id: { type: 'relation', to: () => types['flowStepDefs'] },
        startType: { type: 'string', values: FLOW_STEP_TYPES },
        originalRequest: { type: 'object' },
        originalHeaders: { type: 'object' },
        originalUrl: { type: 'string' },
        originalRequestUrl: { type: 'string' },
        flowIncomingEmail_id: { type: 'relation', to: () => types['flowIncomingEmails'] },
    }; },
    relations: (types) => { return {
        runs: {
            to: types['testRuns'],
            hasPaging: true,
            permissionFunc: hasSnapshotTestDeveloperPermission,
            args: {
                id: {
                    type: 'ID',
                    asFilter: true,
                },
            },
        }
    }; }
});
